<section class="flex flex-col flex-auto w-full p-4 xs:p-2">
  <section class="flex flex-wrap w-full">
    <!-- Comps Header -->
    <section class="w-full pb-4">
      <div class="flex items-center">
        @if (!editTitle()) {
          <h2 data-cy="comp-title" class="m-0 mr-4 leading-none">{{ compset.title }}</h2>
          <ts-button
            data-cy="comp-edit-title"
            [type]="'icon'"
            [icon]="'edit'"
            [color]="'basic'"
            (click)="openEditTitle()"
            [appAuthorize]="canEditDeal()"
            denyAction="disable"
          />
          <ts-button
            class="ml-2"
            [type]="'icon'"
            [icon]="'ts_trash-alt'"
            [color]="'warn'"
            (click)="deleteCompset()"
            [appAuthorize]="canEditDeal()"
            denyAction="disable"
          />
        }

        @if (editTitle()) {
          <div class="flex items-center w-2/3">
            <mat-form-field class="flex-auto">
              <input matInput [(ngModel)]="title" />
            </mat-form-field>
            <ts-button
              class="ml-2 mx-2"
              data-cy="comp-edit-title-cancel"
              [type]="'icon'"
              [icon]="'close'"
              [color]="'warn'"
              (click)="discardTitle()"
            ></ts-button>
            <ts-button
              class="ml-2 mx-2"
              data-cy="comp-edit-title-save"
              [type]="'icon'"
              [icon]="'save'"
              [color]="'basic'"
              (click)="saveTitle()"
            ></ts-button>
          </div>
        }
      </div>
      <p class="text-secondary tracking-tight my-3">Explore your own data to find comps to the subject property.</p>
    </section>

    <section class="flex w-full flex-row gap-4 mb-3" [class.editing-comp]="editing()">
      <!-- Averages -->
      <div class="flex flex-col w-1/3">
        <div class="flex flex-row shadow-md flex-auto bg-card rounded flex-col">
          <div class="flex flex-col p-4 pl-6">
            <div class="flex items-center justify-between">
              <div class="font-bold text-md text-secondary uppercase tracking-wider">Averages</div>
            </div>
          </div>
          <div class="flex flex-col flex-auto justify-end text-md px-6 pb-3">
            <div
              class="flex items-center justify-between py-3 border-b last:border-b-0"
              *ngFor="let item of averages; let i = index"
            >
              <ng-container *ngIf="lookupField(item.key) as fieldDef">
                <div class="flex items-center w-2/3">
                  <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full"></div>
                  <div class="truncate">{{ fieldDef.label }}</div>
                </div>
                <div class="w-1/3 font-medium text-right">
                  <ng-container *ngIf="fieldDef.type === 'money'">
                    {{ item.value | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                  </ng-container>
                  <ng-container *ngIf="fieldDef.type === 'percent'">
                    {{ item.value / 100 | percent: '1.2-2' }}
                  </ng-container>
                  <ng-container *ngIf="fieldDef.type === 'number' || fieldDef.type === 'decimal'">
                    {{ item.value | number: '1.0-0' }}
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Map -->
      <div class="flex flex-col w-2/3">
        <div class="flex flex-row bg-card shadow-md rounded overflow-hidden">
          <mgl-map
            [style]="selectedMapStyle"
            [zoom]="[6]"
            [minZoom]="4"
            [projection]="'mercator'"
            [fitBounds]="bounds"
            [fitBoundsOptions]="{
              padding: 100,
            }"
            [center]="[property?.address?.longitude, property?.address?.latitude]"
          >
            <mgl-control mglFullscreen></mgl-control>
            <ng-container *ngFor="let comp of selectedItemsDatasource.data">
              <mgl-marker #myMarker [lngLat]="[comp.longitude, comp.latitude]">
                <div class="marker">
                  <span
                    ><b>{{ comp.index }}</b></span
                  >
                </div>
              </mgl-marker>
              <mgl-popup [marker]="myMarker">
                <a
                  [routerLink]="['/projects/' + comp.pipeline_id + '/' + comp.id]"
                  class="font-semibold text-xs tracking-wider"
                >
                  <strong>{{ comp.title }}</strong>
                </a>
                <p class="font-semibold text-xs tracking-wider">
                  {{ comp.address_string }}
                </p>
                <ng-container *ngFor="let column of getTableColumns(); index as i">
                  <ng-container *ngIf="lookupField(column) as fieldDef">
                    <p>
                      <span class="text-xs uppercase tracking-wider">{{ fieldDef.label }}: </span>
                      <span class="font-semibold text-xs uppercase tracking-wider">
                        <ng-container *ngIf="fieldDef.type === 'money'">
                          {{ comp[column] | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                        </ng-container>
                        <ng-container *ngIf="fieldDef.type === 'percent'">
                          {{ comp[column] / 100 | percent: '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="fieldDef.type === 'datetime' || fieldDef.type === 'date'">
                          {{ comp[column] | date: 'MM/dd/yyyy' }}
                        </ng-container>
                        <ng-container *ngIf="fieldDef.type === 'number' || fieldDef.type === 'decimal'">
                          {{ comp[column] | number: '1.0-0' }}
                        </ng-container>
                        <ng-container *ngIf="isFieldTypeAllowedForPopup(fieldDef)">
                          {{ comp[column] }}
                        </ng-container>
                      </span>
                    </p>
                  </ng-container>
                </ng-container>
              </mgl-popup>
            </ng-container>

            <ng-container *ngIf="property">
              <mgl-marker #subjectMarker [lngLat]="[property.address?.longitude, property.address?.latitude]">
                <div class="marker marker--subject">
                  <span
                    ><b><mat-icon [svgIcon]="'home'"></mat-icon></b
                  ></span>
                </div>
              </mgl-marker>
              <mgl-popup [marker]="subjectMarker">
                <p class="font-semibold text-sm tracking-wider">
                  {{ property.name }}
                </p>
                <p class="font-semibold text-xs tracking-wider">
                  {{ property.address_string }}
                </p>
                <ng-container *ngFor="let column of getTableColumns(); index as i">
                  <ng-container *ngIf="lookupField(column) as fieldDef">
                    <p>
                      <span class="text-xs uppercase tracking-wider">{{ fieldDef.label }}: </span>
                      <span class="font-semibold text-xs uppercase tracking-wider">
                        <ng-container *ngIf="fieldDef.type === 'money'">
                          {{ property[column] | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                        </ng-container>
                        <ng-container *ngIf="fieldDef.type === 'percent'">
                          {{ property[column] / 100 | percent: '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="fieldDef.type === 'datetime' || fieldDef.type === 'date'">
                          {{ property[column] | date: 'MM/dd/yyyy' }}
                        </ng-container>
                        <ng-container *ngIf="fieldDef.type === 'number' || fieldDef.type === 'decimal'">
                          {{ property[column] | number: '1.0-0' }}
                        </ng-container>
                        <ng-container *ngIf="isFieldTypeAllowedForPopup(fieldDef)">
                          {{ property[column] }}
                        </ng-container>
                      </span>
                    </p>
                  </ng-container>
                </ng-container>
              </mgl-popup>
            </ng-container>

            <ng-container *ngFor="let layer of layers">
              <mgl-geojson-source [id]="layer.id" [data]="layer.url"> </mgl-geojson-source>
              <mgl-layer
                [id]="layer.id"
                [source]="layer.id"
                [type]="layer.type"
                [paint]="{
                  'circle-color': 'red',
                }"
              ></mgl-layer>
            </ng-container>
          </mgl-map>
        </div>
      </div>
    </section>

    <!-- Property Table -->
    <section class="w-full" #compsEdit>
      <ng-container *ngIf="isCompsetStatic && !editing()">
        <div class="flex flex-col p-4 pl-6 w-full items-end bg-white">
          <ts-menu [items]="compsMenuOptions" />
        </div>
        <div
          class="flex w-full flex-col bg-card shadow-md rounded table-container"
          *ngIf="selectedItemsDatasource?.data.length > 0 || isLoading(); else emptyComps"
        >
          @if (isLoading()) {
            <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
          }
          <table
            class="bg-transparent"
            mat-table
            matSort
            [matSortActive]="sortBy"
            [matSortDirection]="sortDirection"
            [dataSource]="selectedItemsDatasource"
            [trackBy]="trackByFn"
            (matSortChange)="announceSortChange($event)"
          >
            <ng-container matColumnDef="index">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t pl-2" mat-header-cell *matHeaderCellDef>
                <app-column-selector
                  [matTooltip]="'Select columns'"
                  [items]="compsetFieldDefs"
                  [selectedOrder]="selectedOrder"
                  [draggable]="true"
                  (onSave)="onSaveColumns($event)"
                ></app-column-selector>
              </th>
              <td mat-cell *matCellDef="let comp">{{ comp.index }}</td>
            </ng-container>

            <ng-container matColumnDef="selected">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t pl-2" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap"></span>
              </th>
              <td mat-cell *matCellDef="let comp"></td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t pl-2" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Name</span>
              </th>
              <td mat-cell *matCellDef="let comp">
                <a
                  *ngIf="compset.object_type === 'Project'"
                  [routerLink]="['/projects/' + comp.pipeline_id + '/' + comp.id]"
                  target="_blank"
                >
                  <span class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                    {{ comp.name }}
                  </span>
                </a>
                <a *ngIf="compset.object_type === 'Property'" [routerLink]="['/properties/' + comp.id]" target="_blank">
                  <span class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                    {{ comp.name }}
                  </span>
                </a>
              </td>
            </ng-container>

            <ng-container matColumnDef="address">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t pl-2" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap">Address</span>
              </th>
              <td mat-cell *matCellDef="let comp">
                <a
                  *ngIf="compset.object_type === 'Project'"
                  [routerLink]="['/projects/' + comp.pipeline_id + '/' + comp.id]"
                  target="_blank"
                >
                  <span class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                    {{ comp.address_string }}
                    <br />
                    {{ comp.property_type_name }}
                  </span>
                </a>
                <a *ngIf="compset.object_type === 'Property'" [routerLink]="['/properties/' + comp.id]" target="_blank">
                  <span class="pr-6 font-medium text-sm text-secondary whitespace-nowrap">
                    {{ comp.address_string }}
                    <br />
                    {{ comp.property_type_name }}
                  </span>
                </a>
              </td>
            </ng-container>

            <ng-container [matColumnDef]="column" *ngFor="let column of getTableColumns(); index as i">
              <ng-container *ngIf="lookupField(column) as fieldDef">
                <th
                  class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t pl-2"
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                >
                  <span class="whitespace-nowrap">
                    {{ fieldDef.label }}
                  </span>
                </th>
                <td mat-cell *matCellDef="let comp">
                  <span class="pr-6 whitespace-nowrap">
                    <ng-container *ngIf="fieldDef.type === 'money'">
                      {{ comp[column] | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                    </ng-container>
                    <ng-container *ngIf="fieldDef.type === 'percent'">
                      {{ comp[column] / 100 | percent: '1.2-2' }}
                    </ng-container>
                    <ng-container *ngIf="fieldDef.type === 'number'">
                      {{ comp[column] | number: '1.0-0' }}
                    </ng-container>
                    <ng-container *ngIf="fieldDef.type === 'decimal'">
                      <!-- Add two digit decimal for dist_miles fieldDef only. -->
                      @if (fieldDef.name === 'dist_miles') {
                        {{ comp[column] | number: '1.2-2' }}
                      } @else {
                        {{ comp[column] | number: '1.1-1' }}
                      }
                    </ng-container>
                    <ng-container *ngIf="fieldDef.type === 'select'">
                      {{ getOptionName(fieldDef, comp[column]) }}
                    </ng-container>
                    <ng-container *ngIf="fieldDef.type === 'datetime' || fieldDef.type === 'date'">
                      {{ comp[column] | date: 'MM/dd/yyyy' }}
                    </ng-container>
                    <ng-container *ngIf="isFieldTypeAllowed(fieldDef)">
                      {{ comp[column] }}
                    </ng-container>
                  </span>
                </td>
              </ng-container>
            </ng-container>

            <ng-container matColumnDef="remove">
              <th class="bg-cool-gray-50 dark:bg-cool-gray-700 border-t pl-2" mat-header-cell *matHeaderCellDef>
                <span class="whitespace-nowrap"></span>
              </th>
              <td mat-cell *matCellDef="let comp">
                <button
                  class="complete-task"
                  mat-icon-butto
                  [matTooltip]="'Remove property from this compset'"
                  (click)="removeComp(comp)"
                >
                  <mat-icon [svgIcon]="'delete'"></mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr
              class="order-row h-16"
              [ngClass]="{ 'selected-row': property && row.property_id === property.id }"
              mat-row
              *matRowDef="let row; columns: displayColumns"
            ></tr>
          </table>
        </div>
      </ng-container>

      <!-- Edit mode or Dynamic compset -->
      <ng-container *ngIf="isCompsetDynamic || editing()">
        <app-comps-edit
          class="w-full mt-4"
          [dataSource]="selectedItemsDatasource"
          (dataSourceChange)="onDataSourceChange($event)"
          [compsetFieldDefs]="compsetFieldDefs"
          [selectedOrder]="selectedOrder"
          [compset]="compset"
          [displayColumns]="requestDisplayColumns()"
          [property]="property"
          [project]="project"
          [data]="data"
          (onSaveColumns)="onSaveColumns($event)"
          (onSave)="onSave($event)"
          (ready)="scrollToEditTable()"
        >
        </app-comps-edit>
      </ng-container>
    </section>
  </section>
</section>

<ng-template #emptyComps>
  <section class="flex flex-col w-full items-center">
    <h5>No properties selected</h5>
    <ts-button [type]="'flat'" [color]="'primary'" (click)="openEditComp()">Add properties</ts-button>
  </section>
</ng-template>
